// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"357": "317eaff7a399b493","757": "582290526d6c1735",}[chunkId] + ".css"
}